import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Product.List.IRequest;
type Response = Api.Core.Product.List.IResponse;
type Headers = Api.Core.Product.List.IHeaders;
const url = '/api/ProductManagement/Product';
export default async function productListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
